import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';

const StatBarItem = ({
  label, value, valueAffix, tooltip,
}) => (
  <div className="dashboard-results__box">
    <div className="dashboard-results__box__result">
      <span className="dashboard-results__box__result__data">
        {tooltip ? (
          <Tooltip title={tooltip}>
            <span>{value}</span>
          </Tooltip>
        ) : (
          <span>{value}</span>
        )}
      </span>
      <span className="dashboard-results__box__result__add-data">
        {valueAffix !== null ? `(${valueAffix})` : ''}
      </span>
    </div>
    <div className="dashboard-results__box__description">{label}</div>
  </div>
);

StatBarItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  valueAffix: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tooltip: PropTypes.string,
};

StatBarItem.defaultProps = {
  label: null,
  tooltip: null,
  value: '-',
  valueAffix: null,
};

export default StatBarItem;
